import React, { useState } from "react";
import CoverAndLogoContent from "./CoverAndLogoContent.js";
import OnlySubscribersAlert from "../../OnlySubscribersAlert.js";
import CheckboxElement from "components/Elements/CheckboxElement/CheckboxElement.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import ToastHtmlComponent from "components/Reusable/ToastHtmlComponent/ToastHtmlComponent.js";
import config from "config";
import Image from "components/Elements/Image/Image.tsx";
import { useUser } from "contexts/userContext/userContext.js";
import { useToasts } from "react-toast-notifications";
import { useContent } from "contexts/contentContext/contentContext.js";

import "./CoverAndLogo.scss";

const CoverAndLogo = () => {
  const { isSubscribed, getUserData } = useUser();
  const [homePageCover, setHomePageCover] = useState(
    getUserData().SetCoverOnNewHomePage
      ? getUserData().SetCoverOnNewHomePage
      : false
  );
  const { addToast } = useToasts();
  const { getTextByKey } = useContent();

  const setHomePageCoverChange = async () => {
    // update api

    const request = {
      homePageCover: !homePageCover,
    };
    const response = await apiRequest(
      "Users",
      "UpdateUserCoverOnHomePage",
      request,
      "PUT"
    );
    if (response.status === "success") {
      setHomePageCover(!homePageCover);
    } else {
      let errText = getTextByKey("api-error");
      errText = errText.replace("#ERRORNUM#", 999);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      errText = errText.replace("#SYSMAIL#", config.supportmail);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      addToast(<ToastHtmlComponent htmlStr={errText} />, {
        appearance: "error",
      });
    }
    return response;
  };

  return (
    <>
      <div className="cover-logo-page">
        <div className="cover-logo-container">
          <div className="cover-logo-top-image">
            <Image name="upload-cover-top" ext="png" alt="" title="" />
          </div>
          <CoverAndLogoContent />
          <div className="cover-logo-bottom-image">
            <Image name="upload-cover-bottom" ext="png" alt="" title="" />
          </div>
        </div>
        {!isSubscribed() && (
          <OnlySubscribersAlert text={"branding-cover-only-subscriber-text"} />
        )}
      </div>
      {isSubscribed() &&
        !getUserData().TopUserBrandingEnabled &&
        getUserData().UserBackgroundCoverImage && (
          <div className="cover-logo-footer-home-page">
            {/* add checkbox that on change will send request to api */}
            <CheckboxElement
              state={homePageCover}
              setState={setHomePageCoverChange}
              checkboxLabel="set-cover-on-home-page"
            />
          </div>
        )}
    </>
  );
};

export default CoverAndLogo;
